<template>
    <div class="main-container">
      <inner-navigation class="grid-order-1" link="/inventory/items" title="Stok Yönetimi" imgURL="inventory.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-2" link="/inventory/categories" title="Ürün Kategorileri" imgURL="categorization.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-1" link="/inventory/brands" title="Markalar" imgURL="brands.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-2" link="/inventory/suppliers" title="Tedarikçiler" imgURL="supplier.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-3" link="/inventory/locations" title="Depolar" imgURL="warehouse.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-4" link="/inventory/worksites" title="Şantiyeler" imgURL="construction.png" navStyle=1></inner-navigation>
    </div>
</template>

<script>

import InnerNavigation from "../InnerNavigation.vue"
import { mapGetters } from 'vuex'

export default {
  name: 'InventoryHome',
  components: {
      InnerNavigation: InnerNavigation
  },
  computed: {
      ...mapGetters('user', {
          userProfile: 'userProfile',
      })
  },
}
</script>

<style scoped lang="scss">

  @import "../../styles/core/variables.scss";
  @import "../../styles/core/resets.scss";
  @import "../../styles/global/background.scss";
  @import "../../styles/global/helpers.scss";

</style>
